import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M7.735 9.173l.941.942L14.32 4.47l.943.942L8.676 12 4.433 7.757l.943-.942L6.793 8.23l.942.942zm.001-1.885l3.301-3.302.94.94-3.3 3.302-.94-.94zm-1.885 3.77L4.91 12 .667 7.757l.942-.942.942.942 3.3 3.301z'
      ></path>
    </svg>
  )
}

export default Icon
